enum OrderExportField {
    SHOP_NAME = "SHOP_NAME",

    ORDER_STATUS = "ORDER_STATUS",

    AMOUNTS = "AMOUNTS",

    BUYER_REMARKS = "BUYER_REMARKS",

    BUYER_USERNAME = "BUYER_USERNAME",

    CITY = "CITY",

    COD_AMOUNTS = "COD_AMOUNTS",

    CONSIGNEE_NAME = "CONSIGNEE_NAME",

    DETAILED_ADDRESS = "DETAILED_ADDRESS",

    DISCOUNTS = "DISCOUNTS",

    DISTRICT = "DISTRICT",

    END_TIME = "END_TIME",

    EXTERNAL_ID = "EXTERNAL_ID",

    FLAG = "FLAG",

    ORDER_MARK = "ORDER_MARK",

    LOGISTICS_COMPANY = "LOGISTICS_COMPANY",

    MOBILE = "MOBILE",

    ORDER_TIME = "ORDER_TIME",

    ORIGINAL_ID = "ORIGINAL_ID",

    PAYMENTS = "PAYMENTS",

    SELLER_RECEIPTS = "SELLER_RECEIPTS",

    PAYMENT_TIME = "PAYMENT_TIME",

    PRODUCT_ORIGINAL_ID = "PRODUCT_ORIGINAL_ID",

    PRODUCT_PRICE = "PRODUCT_PRICE",

    ORDER_ITEM_COST = "ORDER_ITEM_COST",

    PRODUCT_QUANTITY = "PRODUCT_QUANTITY",

    PRODUCT_REFUNDING = "PRODUCT_REFUNDING",

    PRODUCT_STOCK_NO = "PRODUCT_STOCK_NO",

    PRODUCT_TITLE = "PRODUCT_TITLE",

    PRODUCT_RAW_TITLE = "PRODUCT_RAW_TITLE",

    PRODUCT_SIMPLE_TITLE = "PRODUCT_SIMPLE_TITLE",

    PRODUCT_WEIGHT = "PRODUCT_WEIGHT",

    PROVINCE = "PROVINCE",

    SELLER_REMARKS = "SELLER_REMARKS",

    SHIPPING_COST = "SHIPPING_COST",

    SHIPPING_TIME = "SHIPPING_TIME",

    SKU_ORIGINAL_ID = "SKU_ORIGINAL_ID",

    SKU_PROPERTIES = "SKU_PROPERTIES",

    STREET = "STREET",

    TELEPHONE = "TELEPHONE",

    WAYBILL_NO = "WAYBILL_NO",

    WEIGHT = "WEIGHT",

    ZIP_CODE = "ZIP_CODE",

    SUPPLIER_NAME = "SUPPLIER_NAME",

    RETAILER_NAME = "RETAILER_NAME",

    SEQUENCE_NO = "SEQUENCE_NO",

    AFFILIATE_MARKETER = "AFFILIATE_MARKETER",

    SHIPPER_NAME = "SHIPPER_NAME",

    SUPPLIER_REMARKS = "SUPPLIER_REMARKS",

    WAYBILL_PRINT_TIME = "WAYBILL_PRINT_TIME",
}

export default OrderExportField;
